import { Sprout, SlidersHorizontal } from 'lucide-react';
import { useTheme } from '../contexts/ThemeContext';
import { useI18n } from '../i18n';
import './Navigation.css';

export default function ExperienceSwitcher({ compact = false }) {
    const { experience, setExperience } = useTheme();
    const { t, locale } = useI18n();
    const copy = (key, da, en) => {
        const translated = t(key);
        return translated && translated !== key ? translated : locale === 'da' ? da : en;
    };
    const choices = [
        { value: 'lightweight', label: copy('experience.simple', 'Simpel', 'Simple'), icon: Sprout },
        { value: 'full', label: copy('experience.advanced', 'Avanceret', 'Advanced'), icon: SlidersHorizontal },
    ];

    return (
        <div
            role="group"
            data-testid="dashboard-experience-switcher"
            aria-label={copy('experience.label', 'Visning', 'View')}
            className={`gd-experience-switcher${compact ? ' gd-experience-switcher--compact' : ''}`}
        >
            {choices.map(({ value, label, icon: Icon }) => (
                <button
                    key={value}
                    type="button"
                    data-testid={`experience-${value}`}
                    aria-pressed={experience === value}
                    onClick={() => setExperience(value)}
                >
                    {!compact && <Icon size={15} strokeWidth={1.8} aria-hidden="true" />}
                    <span>{label}</span>
                </button>
            ))}
        </div>
    );
}
